// LoginStepSignup.jsx

import React from 'react';

// CSS
import './LoginStepSignup.css';

// Components
import Button from 'components/button/Button';
import TextInput from 'components/textinput/TextInput';
import WizardStep from 'components/wizard/WizardStep';
import WizardStepContent from 'components/wizard/WizardStepContent';
import LoginLabel from 'login/label/LoginLabel';

/**
 * LoginStepSignup
 *
 * @returns {ReactNode} The rendered component.
 */
const LoginStepSignup = ({
  currentStep,
  direction,
  isAutoHeight,
  theme,
  signupEmailInputRef,
  signupEmail,
  signupName,
  signupPassword,
  signupFormValid,
  passwordRequirements,
  handleSignupEmailChange,
  handleSignupEmailBlur,
  handleSignupNameChange,
  handleSignupPasswordChange,
  handleSignup,
}) => {

  // ----- RENDER ----- //

  return (
  <WizardStep
    step={2}
    currentStep={currentStep}
    direction={direction}
    isAutoHeight={isAutoHeight}
  >
    <WizardStepContent>
      <div className="login-form-container">
        <div className="login-field-container">
          <LoginLabel text="Email Address" />
          <TextInput
            ref={signupEmailInputRef}
            placeholder="Email Address..."
            value={signupEmail}
            required={true}
            type="text"
            onBlur={handleSignupEmailBlur}
            onChange={handleSignupEmailChange}
            onEnterPress={handleSignup}
          />
        </div>

        <div className="login-field-container">
          <LoginLabel text="Name" />
          <TextInput
            placeholder="Name..."
            value={signupName}
            required={true}
            type="text"
            onChange={handleSignupNameChange}
            onEnterPress={handleSignup}
          />
        </div>

        <div className="login-field-container">
          <div className="login-label-row">
            <LoginLabel text="Password" />
          </div>

          <TextInput
            placeholder="Password..."
            value={signupPassword}
            required={true}
            type="password"
            onChange={handleSignupPasswordChange}
            onEnterPress={handleSignup}
          />
        </div>

        <div
          className="login-password-requirements"
        >
          {passwordRequirements.map((requirement, index) => (
            <li key={index}>{requirement}</li>
          ))}
        </div>

        <div className="login-button-wrapper">
          <Button
            label="Continue..."
            enabled={signupFormValid}
            height={44}
            onClick={handleSignup}
          />
        </div>
      </div>
    </WizardStepContent>
  </WizardStep>
);
};

// Dev Tools
LoginStepSignup.displayName = 'LoginStepSignup';

export default React.memo(LoginStepSignup);
